import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { EmailClipModule } from '@platform-frontend/account-ui';
import { CountryModule } from '@platform-frontend/marketplace';
import { LegalModule } from '@platform-frontend/platform';
import {
  ButtonModule,
  CommonWordingModule,
  FormsModule,
  IconsModule,
  LinkModule,
  LoadingIndicatorModule,
  TabSelectableModule,
  TemplateVariablesModule,
  TooltipModule,
  icoChevronRight,
  icoCogDuo,
  icoCrossCircleDuo,
  icoDeleteDuo,
  icoEditFieldDuo,
  icoInfoDuo,
  icoPlusCircle,
  icoPlusCircleDuo,
  icoTickCircleDuo
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { CheckoutCountryModule } from '../country';
import { DrawDialogModule } from '../draw-dialog';
import { AccountingEmailComponent } from './accounting-email/accounting-email.component';
import { BillingAddressFormComponent } from './billing-address-form/billing-address-form.component';
import { BillingAddressPanelComponent } from './billing-address-panel/billing-address-panel.component';
import { CommonBillingWordingPipe } from './common-billing-wording.pipe';
import { NoBillingAddressSelectedPanelComponent } from './no-billing-address-selected-panel/no-billing-address-selected-panel.component';
import { NoBillingAddressComponent } from './no-billing-address/no-billing-address.component';
import { VatIdPipe } from './vat-id.pipe';

@NgModule({
  declarations: [
    AccountingEmailComponent,
    BillingAddressFormComponent,
    BillingAddressPanelComponent,
    CommonBillingWordingPipe,
    NoBillingAddressSelectedPanelComponent,
    NoBillingAddressComponent,
    VatIdPipe
  ],
  imports: [
    ButtonModule,
    CheckoutCountryModule,
    CommonModule,
    CommonWordingModule,
    CountryModule,
    EmailClipModule,
    FormsModule,
    IconsModule.withIcons(
      icoCogDuo,
      icoChevronRight,
      icoEditFieldDuo,
      icoCrossCircleDuo,
      icoInfoDuo,
      icoDeleteDuo,
      icoPlusCircleDuo,
      icoTickCircleDuo,
      icoPlusCircle
    ),
    LinkModule,
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    TabSelectableModule,
    TemplateVariablesModule,
    TranslocoModule,
    TranslocoMarkupModule,
    TooltipModule,
    LegalModule,
    DrawDialogModule
  ],
  exports: [
    AccountingEmailComponent,
    BillingAddressFormComponent,
    BillingAddressPanelComponent,
    CommonBillingWordingPipe,
    NoBillingAddressSelectedPanelComponent,
    NoBillingAddressComponent
  ]
})
export class CheckoutBillingInformationModule {}
